/**
 * The 1px rule between two controls in a segmented group.
 *
 * A `border-l` on the right-hand child would be the obvious thing, but every trigger in the pill
 * carries `border-none` (the group box owns the border), and `border-style: none` kills any
 * border width set alongside it. A sibling element sidesteps that entirely.
 */
export function SegmentSeam() {
  return <span aria-hidden className="w-px flex-shrink-0 self-stretch bg-input" />
}
